export default "__VITE_ASSET__wN$zVU0e__"